import Icon from "@material-ui/icons/Eco";

import Add from "./Add";
import Edit from "./Edit";
import List from "./List";

const Pools = { Icon, Add, Edit, List };

export default Pools;
